import { useEffect, useRef } from "react";
import Lenis from "lenis";
import { useSite } from "@/context/SiteContext";
import { trackVisit } from "@/lib/api";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { MarqueeStrip } from "@/components/landing/Marquee";
import { Story } from "@/components/landing/Story";
import { Testimonials } from "@/components/landing/Testimonials";
import { FloatingWhatsApp } from "@/components/landing/FloatingWhatsApp";
import { FooterBar } from "@/components/layout/SubpageShell";

export default function Landing() {
  const { content, loading } = useSite();
  const lenisRef = useRef(null);

  useEffect(() => {
    if (sessionStorage.getItem("cb_tracked")) return;
    sessionStorage.setItem("cb_tracked", "1");
    trackVisit().catch(() => {});
  }, []);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  const scrollTo = (target) => {
    if (lenisRef.current) {
      lenisRef.current.scrollTo(target, { offset: -64, duration: 1.4 });
    }
  };

  if (loading || !content) {
    return (
      <div data-testid="landing-loader" className="min-h-screen grid place-items-center bg-[#F8FAFC]">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 rounded-2xl bg-sky-400 animate-pulse" />
          <p className="text-sm font-semibold text-slate-400">Loading…</p>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="landing-page" className="bg-[#F8FAFC]">
      <Navbar onNav={scrollTo} />
      <Hero onNav={scrollTo} />
      <MarqueeStrip />
      <Story />
      <Testimonials />
      <FooterBar />
      <FloatingWhatsApp />
    </div>
  );
}
